import { useSearchParams } from 'react-router-dom';
import { getLocalItem } from '~/adapters/appStorage.ts';

function useGetRedirectToParam(defaultValue?: string): string;
function useGetRedirectToParam(defaultValue?: null): string | null;
function useGetRedirectToParam(defaultValue: string | undefined | null = null) {
  const [searchParams] = useSearchParams();

  return searchParams.get('redirectTo') || getLocalItem('redirectTo') || defaultValue;
}

export { useGetRedirectToParam };
